<template>
    <div
        :class="{ 'opacity-40': isActive }"
        class="transition flex flex-col gap-6 pl-4 border-l border-white text-left whitespace-nowrap !w-[280px] lg:!w-[25vw]"
    >
        <div>
            <div class="mb-2">{{ video.title }}</div>
        </div>

        <div class="w-[70px] h-[50px] rounded overflow-hidden">
            <img class="h-full w-full object-cover" :src="thumbnail" alt=""/>
        </div>
    </div>
</template>

<script>
import secondsToMinutes from "../../../utils/secondsToMinutes";
import videoInfos from "../../../mixins/video-infos";

export default {
    name: "MoleculeSliderVideo",
    props: {
        video: Object,
        isActive: Boolean,
    },
    mixins: [videoInfos],
    methods: {
        secondsToMinutes
    },
    mounted() {
        this.getVideoInfos(this.video)
    },
}
</script>

<style scoped>

</style>
